export enum EXTENSION {
    PSD = 'psd',
    PDF = 'pdf',
    JAVASCRIPT = 'js',
    JS = 'js',
    HTML = 'html',
    CSV = 'csv',
    CSS = 'css',
    JPG = 'jpg',
    JPEG = 'jpg',
    PNG = 'png',
}

/**
 * Convert filenames that don't have an extension to filenames with an extension
 * ignoring it if the filename already have the extension
 * @param filename
 * @param extension
 */
export function optionalExtension(filename: string, extension: EXTENSION): string {
    if (filename && !filename.endsWith(`.${extension}`)) {
        return `${filename}.${extension}`;
    }

    return filename ?? '';
}
